import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { Form } from '@leshen/ui'
import defaultAvailabilityAddressSubmit from './availabilityAddressSubmit'
import AvailabilityAddressSubmissionMessage from './AvailabilityAddressSubmissionMessage'
import { useUser } from '../../../../context/UserProvider'

const AvailabilityAddress = ({
  label = null,
  placeholderText = 'Enter your street address',
  buttonText = 'Find',
  buttonColor = 'primary',
  buttonOutlined = false,
  buttonGradient = false,
  handleSubmit = defaultAvailabilityAddressSubmit,
}) => {
  const data = useStaticQuery(graphql`
    query AvailabilityAddressQuery {
      site {
        siteMetadata {
          addressQualificationCode
          smartyStreetsWebsiteKey
        }
      }
    }
  `)

  const { addressQualificationCode, smartyStreetsWebsiteKey } =
    data.site.siteMetadata

  const [isSubmitted, setIsSubmitted] = useState(false)
  const { setAddressLocation, isLoading, setUserData } = useUser()

  const addressField = [
    {
      label,
      name: 'address',
      value: '',
      required: true,
      type: 'text',
      placeholderText,
    },
  ]

  return (
    <>
      <Form
        formSource="static"
        fields={addressField}
        smartyStreetsWebsiteKey={smartyStreetsWebsiteKey}
        inlineButton
        submitButtonText={buttonText}
        submitButtonColor={buttonColor}
        submitButtonOutlined={buttonOutlined}
        submitButtonGradient={buttonGradient}
        onSubmit={({ values }) => {
          setAddressLocation({
            address: values.address.value,
            smartyStreetsWebsiteKey,
            addressQualificationCode,
          })
          handleSubmit({ values, setIsSubmitted, setUserData })
        }}
      />
      {isSubmitted && !isLoading && <AvailabilityAddressSubmissionMessage />}
    </>
  )
}

export default AvailabilityAddress
